import ProjectStyle2 from "./ProjectStyle2";
import {storyblokEditable} from "@storyblok/react";
import ProjectStyle1 from "./ProjectStyle1";
import {IProjectItem} from "../../types/IProjectItem";

type IProps = {
    blok: any
}

export default function Project(props: IProps) {
    const blokData = props.blok;

    // For some reason, the Storyblok Api call of the projects returns blok data in a "content" key
    const item: IProjectItem = {
        content: blokData,
    } as IProjectItem;

    let project;
    switch (item.content.render_style) {
        case "2":
            project = <ProjectStyle2 item={item} year={item.content.year}/>
        default:
            project = <ProjectStyle1 item={item} year={item.content.year}/>
    }

    return <div className={'max-w-screen-2xl mx-auto  px-4 sm:px-6 lg:px-8'} {...storyblokEditable(blokData)}
                >
        <div className={'grid grid-cols-6'}>
            <div className={'hidden sm:block col-span-2 lg:col-span-1 h-full'}>
                <div className={'text-2xl lg:text-3xl sticky pt-5 top-8 font-bold'}>
                    {item.content.ongoing && 'Ongoing'}
                    {!item.content.ongoing && <span>{item.content.year_end}</span>}
                </div>
            </div>
            <div className={'col-span-6 sm:col-span-4 lg:col-span-5 relative'}>
                {project}
            </div>
        </div>
    </div>
}